// Minimal shim for react-onclickoutside to avoid importing findDOMNode in React 19.
// It acts as a no-op HOC, simply forwarding refs to the wrapped component.
// Note: This disables the outside-click behavior used by react-datepicker dropdowns.
// If needed, we can implement a full outside-click handler later using refs and document listeners.

import React from "react";

export default function onClickOutside(WrappedComponent /*, config = {} */) {
  const WithNoopOnClickOutside = React.forwardRef((props, ref) => {
    return <WrappedComponent {...props} ref={ref} />;
  });

  const wrappedName = WrappedComponent.displayName || WrappedComponent.name || "Component";
  WithNoopOnClickOutside.displayName = `onClickOutside(${wrappedName})`;

  return WithNoopOnClickOutside;
}